import { CheckPhoneNumberReq, checkPhoneNumberRes, VerifyPhoneNumberReq } from './models';
import { createMutation } from '../../libs';

export const useCheckVerifyPhoneNumber = createMutation<
  checkPhoneNumberRes,
  CheckPhoneNumberReq
>({
  method: 'post',
  url: `guest-users/phone-number`,
});

export const useVerifyGuestOtp = createMutation<
  checkPhoneNumberRes,
  VerifyPhoneNumberReq
>({
  method: 'post',
  url: `guest-users/verify`,
});
